<template>
  <div>
    <b-row class="mb-4">
      <b-col md="11"> </b-col>
      <b-col md="1">
        <span class="icon-small">
          <i
            class="fa fa-download fa-lg mt-3 pt-0 ml-0 clickIcon"
            style="color: #555;"
            @click="my_wt_download"
          ></i>
        </span>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          style="font-size: 8.5pt;"
          :items="filteredObjects"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="Tracker.DateSecureZips" slot-scope="data">
            {{
              getDisabled(
                data.item.Tracker.DateSecureZips,
                data.item.Tracker.SecureZipsNA
              )
            }}
          </template>
          <template slot="Tracker.DateSecureZips" slot-scope="data">
            {{
              getDisabled(
                data.item.Tracker.DateSecureZips,
                data.item.Tracker.SecureZipsNA
              )
            }}
          </template>
          <template slot="Tracker.DateCountRequest" slot-scope="data">
            {{
              getDisabled(
                data.item.Tracker.DateCountRequest,
                data.item.Tracker.CountRequestNA
              )
            }}
          </template>
          <template slot="Tracker.DateCountApproval" slot-scope="data">
            {{
              getDisabled(
                data.item.Tracker.DateCountApproval,
                data.item.Tracker.CountApprovalNA
              )
            }}
          </template>
          <template slot="Tracker.DateUpdateTM" slot-scope="data">
            {{
              getDisabled(
                data.item.Tracker.DateUpdateTM,
                data.item.Tracker.UpdateTMNA
              )
            }}
          </template>
          <template slot="Tracker.DatePlacedOrderVendor" slot-scope="data">
            {{
              getDisabled(
                data.item.Tracker.DatePlacedOrderVendor,
                data.item.Tracker.PlacedOrderVendorNA
              )
            }}
          </template>
          <template slot="Tracker.DatePlacedNote" slot-scope="data">
            {{
              getDisabled(
                data.item.Tracker.DatePlacedNote,
                data.item.Tracker.PlacedNoteNA
              )
            }}
          </template>
          <template slot="Tracker.DateEmailMarketer" slot-scope="data">
            {{
              getDisabled(
                data.item.Tracker.DateEmailMarketer,
                data.item.Tracker.EmailMarketerNA
              )
            }}
          </template>
          <template slot="Tracker.DateAddedToPPT" slot-scope="data">
            {{
              getDisabled(
                data.item.Tracker.DateAddedToPPT,
                data.item.Tracker.AddedToPPTNA
              )
            }}
          </template>
          <template slot="Tracker.DateAddedToMap" slot-scope="data">
            {{
              getDisabled(
                data.item.Tracker.DateAddedToMap,
                data.item.Tracker.AddedToMapNA
              )
            }}
          </template>
          <template slot="Tracker.DatePlacedOrderProducer" slot-scope="data">
            {{
              getDisabled(
                data.item.Tracker.DatePlacedOrderProducer,
                data.item.Tracker.PlacedOrderProducerNA
              )
            }}
          </template>
          <template slot="Tracker.DateAddedToTS" slot-scope="data">
            {{
              getDisabled(
                data.item.Tracker.DateAddedToTS,
                data.item.Tracker.AddedToTSNA
              )
            }}
          </template>
          <template slot="Tracker.DateNewProducerPerc" slot-scope="data">
            {{
              getDisabled(
                data.item.Tracker.DateNewProducerPerc,
                data.item.Tracker.NewProducerPercNA
              )
            }}
          </template>
          <template slot="Tracker.DateMailLanded" slot-scope="data">
            {{
              getDisabled(
                data.item.Tracker.DateMailLanded,
                data.item.Tracker.MailLandedNA
              )
            }}
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRowsFiltered"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";

export default {
  data: () => {
    return {
      fields: [
        // {
        //   key: "SeminarID",
        //   label: "ID",
        //   sortable: true,
        //   thStyle: "width: 5%;"
        // },
        {
          key: "TerritoryName",
          label: "Territory",
          sortable: true,
          thStyle: "width: 10%;"
        },
        {
          key: "SeminarDates",
          label: "Dates",
          sortable: true
        },
        {
          key: "Vendor",
          label: "Vendor",
          sortable: true
        },
        {
          key: "Tracker.DateSecureZips",
          label: "Zips Secure",
          sortable: true,
          formatter: "mmdd"
        },
        {
          key: "Tracker.DateAddedToPPT",
          label: "Added to PPT",
          sortable: true,
          formatter: "mmdd"
        },
        {
          key: "Tracker.DateCountRequest",
          label: "Counts Req'd",
          sortable: true,
          formatter: "mmdd"
        },
        {
          key: "Tracker.DateCountApproval",
          label: "Counts Apprv'd",
          sortable: true,
          formatter: "mmdd"
        },
        {
          key: "Tracker.DateUpdateTM",
          label: "Update TM",
          sortable: true,
          formatter: "mmdd"
        },
        {
          key: "Tracker.DatePlacedOrderVendor",
          format: "MM/DD/YY",
          label: "Order Placed",
          sortable: true,
          formatter: "mmdd"
        },
        {
          key: "Tracker.DatePlacedNote",
          label: "HQ Note",
          sortable: true,
          formatter: "mmdd"
        },
        {
          key: "Tracker.DateEmailMarketer",
          label: "Email Mrktg",
          sortable: true,
          formatter: "mmdd"
        },
        {
          key: "Tracker.DatePlacedOrderProducer",
          label: "Email Prod.",
          sortable: true,
          formatter: "mmdd"
        },
        {
          key: "Tracker.DateAddedToTS",
          label: "Tues. Sheet",
          sortable: true,
          formatter: "mmdd"
        },
        {
          key: "Tracker.DateNewProducerPerc",
          label: "New Prod. %",
          sortable: true,
          formatter: "mmdd"
        },
        {
          key: "Tracker.DateMailLanded",
          label: "Mail Landed",
          sortable: true,
          formatter: "mmdd"
        },
        {
          key: "Tracker.DateAddedToMap",
          label: "Done",
          sortable: true,
          formatter: "mmdd"
        },
        {
          key: "Tracker.TrackingNotes",
          label: "Notes",
          sortable: true
        }
      ],
      currentPage: 1,
      perPage: 25,
      filteredObjects: []
    };
  },
  components: {
    cTable
  },
  async created() {
    this.refreshReport();
  },
  computed: {
    totalRows: function() {
      return this.$store.state.seminar.seminars.length;
      //return 4;
    },
    totalObjects: function() {
      return this.$store.state.seminar.seminars;
      //return 4;
    },
    totalRowsFiltered: function() {
      return this.filteredObjects.length;
    },
    isNavVisible: function() {
      return this.totalRowsFiltered > this.perPage;
    },
    ...mapState(["seminar", "globals"])
  },
  methods: {
    my_wt_download() {
      var _op = {
        FromDate: this.$store.state.globals.default_from_date,
        ToDate: this.$store.state.globals.default_to_date,
        OrderedBy: this.$store.state.globals.default_pp,
        SearchString: this.$store.state.globals.default_search_string.toLowerCase()
      };
      console.log(_op);
      this.$store
        .dispatch("seminar/DownloadWTReport", _op)
        .then(response =>
          window.open(
            "http://rm_api.revolutionterritorymanager.com/Output/" +
              response.data["FilteredWeeklyPlannerReportDownloadResult"],
            "_blank"
          )
        );
    },
    async refreshReport() {
      var _op = {
        FromDate: this.$store.state.globals.default_from_date,
        ToDate: this.$store.state.globals.default_to_date,
        UserProfileID: this.$store.state.globals.default_pp
      };
      await this.$store.dispatch("seminar/GetFilteredWTEntries", _op);
      this.filterList();
    },
    getDisabled(field, determinedby) {
      if (determinedby == true) {
        return this.mmdd(field);
      } else {
        return "n/a";
      }
    },
    mmdd(value) {
      if (value) {
        return value.substr(0, value.lastIndexOf("/"));
      }
    },
    myRowClickHandler(record, index) {
      this.$store
        .dispatch("seminar/loadSeminarEdit", record.SeminarID)
        .then(() => {
          this.$router.push({ name: "Seminar" });
        });
    },
    filterList: function() {
      this.filteredObjects = this.$store.state.seminar.tracking_entries.filter(
        seminar =>
          (seminar.UserProfileID === this.$store.state.globals.default_pp ||
            !this.$store.state.globals.default_pp) &&
          (seminar.TerritoryName.toLowerCase().indexOf(
            this.$store.state.globals.default_search_string.toLowerCase()
          ) > -1 ||
            seminar.Vendor.toLowerCase().indexOf(
              this.$store.state.globals.default_search_string.toLowerCase()
            ) > -1)
      );
    }
  },
  watch: {
    totalObjects: function(newValue, oldValue) {
      //this.$store.dispatch("seminar/fetchSeatings").then(this.filterList());
    },
    "$store.state.globals.default_from_date": function(newValue, oldValue) {
      //this.filterList();
      this.refreshReport();
    },
    "$store.state.globals.default_to_date": function(newValue, oldValue) {
      //this.filterList();
      this.refreshReport();
    },
    "$store.state.globals.default_pp": function(newValue, oldValue) {
      //this.filterList();
      this.refreshReport();
    },
    "$store.state.globals.default_search_string": function(newValue, oldValue) {
      this.filterList();
    }
  }
};
</script>

<style lang="scss" scoped></style>
